<template>
  <component
    :is="plain ? 'div' : 'BaseCard'"
    :gray="!plain || undefined"
  >
    <BaseText
      v-if="plain"
      bold
      mb
    >
      {{ t('promote.booking_widget.qr_code.heading') }}
    </BaseText>
    <BaseHeading
      v-else
      mb
    >
      {{ t('promote.booking_widget.qr_code.heading') }}
    </BaseHeading>
    <BaseText mb>
      {{ t('promote.booking_widget.qr_code.description') }}
    </BaseText>
    <div :class="$style.content">
      <img
        v-if="pngDataUrl"
        :src="pngDataUrl"
        :alt="t('promote.booking_widget.qr_code.alt')"
        :class="$style.image"
        v-test="'booking-qr-code-image'"
      >
      <BaseButton
        icon="download"
        :disabled="!pngDataUrl"
        @click="download"
        v-test="'booking-qr-code-download'"
      >
        {{ t('promote.booking_widget.qr_code.download_png') }}
      </BaseButton>
    </div>
  </component>
</template>

<script
  setup
  lang="ts"
>
import QRCode from 'qrcode';
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  url: string;
  // Without the card, for pages where it sits between other content
  plain?: boolean;
}>();

const { t } = useI18n();

const pngDataUrl = ref('');

watch(
  () => props.url,
  async (url) => {
    pngDataUrl.value = url
      ? await QRCode.toDataURL(url, {
          errorCorrectionLevel: 'M',
          margin: 2,
          // Large enough to stay sharp when printed on A4
          width: 1024,
        })
      : '';
  },
  { immediate: true },
);

const download = () => {
  const link = document.createElement('a');
  link.href = pngDataUrl.value;
  link.download = 'booking-qr-code.png';
  link.click();
};
</script>

<style
  lang="scss"
  module
>
.content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: $spacing;
}

.image {
  width: 96px;
  height: 96px;
  background-color: white;
  border-radius: $radius;
}
</style>
